import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Col, Divider, Row } from '_zari/core'

import * as Modals from './modals'
import * as Tables from './tables'

import * as UsuarioService from 'services/usuario.service'

const TablaFirmaSection = ({ username }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarAsignarFirmaModal, setMostrarAsignarFirmaModal] = React.useState(false)
  const [listaFirmas, setListaFirmas] = React.useState([])

  const actualizarTabla = React.useCallback(() => {
    __zariContext.loader.open('Obteniendo firmas')

    UsuarioService.obtenerxIdAsInfoFirmas(username)
      .then(({ data }) => {
        if (data) {
          setListaFirmas(data)
        }
        __zariContext.toast('success', 'Se ha actualizado la tabla de firmas.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, username])

  const clickAsignarFirma = React.useCallback(() => {
    setMostrarAsignarFirmaModal(true)
  }, [])

  React.useEffect(() => {
    actualizarTabla()
  }, [actualizarTabla])

  return (
    <>
      <Divider title='Firmas asignadas' />
      <Row>
        <Col md={12} className='text-right'>
          <Button outline tiny onClick={clickAsignarFirma}>
            Asignar firma
          </Button>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md={12}>
          <Tables.FirmasTable listaFirmas={listaFirmas} actualizarTabla={actualizarTabla} username={username} />
        </Col>
      </Row>
      {mostrarAsignarFirmaModal && (
        <Modals.AsignarFirmaModal
          show={mostrarAsignarFirmaModal}
          handleClose={() => setMostrarAsignarFirmaModal(false)}
          actualizarTabla={actualizarTabla}
          username={username}
        />
      )}
    </>
  )
}

export default React.memo(TablaFirmaSection)
